import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

/**
 * Listed one by one so the build only emits the locales the app offers,
 * rather than every locale Day.js ships. English is built in.
 */
export const dateLocaleLoaders: Record<string, () => Promise<unknown>> = {
  'de': () => import('dayjs/locale/de.js'),
  'el': () => import('dayjs/locale/el.js'),
  'es': () => import('dayjs/locale/es.js'),
  'fr': () => import('dayjs/locale/fr.js'),
  'it': () => import('dayjs/locale/it.js'),
  'pt-br': () => import('dayjs/locale/pt-br.js'),
};

export default dayjs;
